module.exports = "<label class=communication-tool-filter__select ng-repeat=\"filter in $ctrl.communicationToolFilterFilters track by filter.name\"> <select tabindex=-10 name={{filter.name}} ng-model=$ctrl.activeFilters[filter.name] ng-change=$ctrl.onChangeFilters() ng-options=\"option as option.label for option in filter.options track by option.value\"> </select> <div class=qw-select__arrow></div> </label> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/communication-tool/communication-tool-filter/communication-tool-filter.template.html
// module id = 540
// module chunks = 0